module.exports = RedNaoFormBuilder.default('FormBuilder/Events/GetModel');